// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-55512cb5],.cls-5[data-v-55512cb5]{fill:#fff3e7}.cls-2[data-v-55512cb5]{fill:var(--v-primary-base)}.cls-3[data-v-55512cb5]{fill:hsla(0,0%,100%,0)}.cls-4[data-v-55512cb5],.cls-5[data-v-55512cb5]{stroke:none}", ""]);
// Exports
module.exports = exports;
